import { otto } from "./nexus-client.mjs";
const o = window;
o.AS || (o.AS = {}), o.o_global || (o.o_global = {}), o.o_util || (o.o_util = {});
o.__toggles__ || (o.__toggles__ = {});
const { o_global: g } = o;
const device = g.device ?? {};
const browser = device.browser;
const hybrid = device.hybrid;
const isTouchable = device.isTouchable;
const orientation = device.orientation;
const os = device.os;
const screen = device.screen;
const type = device.type;
const getPointerType = (otto.device ?? {}).getPointerType;
export {
  browser,
  device,
  getPointerType,
  hybrid,
  isTouchable,
  orientation,
  os,
  screen,
  type
};
/*                                      */
